import { Drawer, Typography, Grid } from '@mui/material'
import { useState } from 'react'
import { HiPlus } from 'react-icons/hi'
import { Button, TextField, Fab, Box, IconButton, Loading } from 'components'
import { useDebounce } from 'utils'
import { MaterialItemList } from './MaterialItemList'
import { useLoadProductRawMaterialsAsProducts } from 'modules/orders/hooks'
import { MdKeyboardArrowLeft, MdSearch } from 'react-icons/md'
import { FixedSizeList as List } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'
import { useItemFormDrawerStore } from '../ItemForm/itemFormDrawerStore'
import { useFormContext } from 'react-hook-form'

export type MaterialsListDrawerProp = {
  onSelect: any
}

export const MaterialsListDrawer = ({ onSelect }: MaterialsListDrawerProp) => {
  const [isNewItemOpen, setIsNewItemOpen] = useState(false)
  const setSelectedItem = useItemFormDrawerStore.useSetSelectedItem()
  const setItemMode = useItemFormDrawerStore.useSetItemMode()
  const [search, setSearch] = useState('')

  const { watch } = useFormContext()

  const orderType = watch('orderType')
  const canAddMaterials = orderType?.id === 'P' || orderType?.id === 'T'

  const searchDebounced = useDebounce(search, 250)

  const {
    data: materials,
    isLoading: materialsLoading,
    isFetching: materialsFetching
  } = useLoadProductRawMaterialsAsProducts(
    {
      search: searchDebounced
    },
    isNewItemOpen && canAddMaterials
  )

  const handleSearch = (event: any) => {
    setSearch(event.target.value.toUpperCase())
  }

  return (
    <>
      <Button
        startIcon={<MdSearch size={18} type="button" />}
        onClick={() => setIsNewItemOpen(true)}
        disabled={!canAddMaterials}
      >
        Procurar material
      </Button>

      <Box
        sx={{
          margin: 0,
          top: 'auto',
          right: 20,
          bottom: 80,
          left: 'auto',
          position: 'fixed',
          display: { md: 'none' },
          zIndex: 10
        }}
      >
        <Fab
          style={{ background: '#023770' }}
          onClick={() => setIsNewItemOpen(true)}
          disabled={!canAddMaterials}
        >
          <HiPlus size={24} color="white" />
        </Fab>
      </Box>
      <Drawer anchor="right" open={isNewItemOpen} onClose={setIsNewItemOpen}>
        <div
          style={{
            maxWidth: 516,
            position: `sticky`,
            top: 0,
            backgroundColor: 'white',
            padding: 8
          }}
        >
          <Grid container spacing={2}>
            <Grid container item alignItems="center" xs={12}>
              <Grid item>
                <IconButton onClick={() => setIsNewItemOpen(false)}>
                  <MdKeyboardArrowLeft
                    size={24}
                    color="#565656"
                    style={{ background: '' }}
                  />
                </IconButton>
              </Grid>
              <Grid item>
                <Typography style={{ marginLeft: `1rem` }} variant="h6">
                  Selecione um material
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <TextField
                placeholder="Pesquisar..."
                style={{ width: '100%' }}
                onChange={handleSearch}
                value={search}
                type="search"
              />
            </Grid>
          </Grid>
        </div>
        <div style={{ padding: 8, maxWidth: 508, height: '100%' }}>
          {(materialsLoading || materialsFetching) && <Loading />}
          {!materials?.data?.length &&
            !(materialsLoading || materialsFetching) && (
              <div>Nenhum material encontrado!</div>
            )}

          <AutoSizer>
            {({ height, width }) => (
              <List
                height={height}
                width={width}
                itemCount={materials?.data?.length || 0}
                itemSize={110}
              >
                {({ index, style }: any) => {
                  const material = materials?.data?.[index]
                  // Normaliza a estrutura do material para ser compatível com produtos
                  const normalizedMaterial = material?.product
                    ? {
                        ...material,
                        product: material.product
                      }
                    : {
                        ...material,
                        product: {
                          id: material?.id,
                          name: material?.name,
                          reference: material?.reference,
                          imageUrl: material?.imageUrl,
                          unitMeasure: material?.unitMeasure
                        }
                      }

                  return (
                    <MaterialItemList
                      key={material?.id || material?.product?.id}
                      item={normalizedMaterial}
                      style={style}
                      onClick={() => {
                        setSelectedItem({
                          ...normalizedMaterial,
                          isMaterial: true
                        })
                        setItemMode('new')
                        onSelect({
                          ...normalizedMaterial,
                          isMaterial: true,
                          sequence: index + 1
                        })
                      }}
                    />
                  )
                }}
              </List>
            )}
          </AutoSizer>
        </div>
      </Drawer>
    </>
  )
}
